import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { contactData } from '../data/mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { path: '/', label: 'Start' },
    { path: '/dienstleistungen', label: 'Dienstleistungen' },
    { path: '/uber-uns', label: 'Über uns' },
    { path: '/kontakt', label: 'Kontakt' }
  ];

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${contactData.whatsapp}`, '_blank');
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50" style={{
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(20px)',
      borderBottom: '1px solid rgba(226, 232, 240, 0.8)',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
    }}>
      <div className="container mx-auto px-4" style={{ maxWidth: '1400px' }}>
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_c62e1435-fe46-42e3-af21-45f9db06585d/artifacts/axk479ew_677c22b58e23f5af78d8ab92_Kein%20Titel%20%28170%20x%2095%20cm%29%20%28200%20x%2070%20cm%29-p-2000.png"
              alt="Crash Check Logo"
              style={{
                height: '45px',
                width: 'auto',
                objectFit: 'contain'
              }}
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map(link => (
              <Link
                key={link.path}
                to={link.path}
                style={{
                  color: isActive(link.path) ? '#0891B2' : '#718096',
                  fontSize: '16px',
                  fontWeight: '500',
                  textDecoration: 'none',
                  transition: 'color 0.3s ease',
                  padding: '8px 0'
                }}
                onMouseEnter={(e) => e.target.style.color = '#0891B2'}
                onMouseLeave={(e) => e.target.style.color = isActive(link.path) ? '#0891B2' : '#718096'}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Buttons Desktop */}
          <div className="hidden md:flex items-center gap-4">
            <button
              onClick={handleWhatsApp}
              className="btn-secondary"
              style={{
                padding: '12px 20px',
                minHeight: '48px',
                fontSize: '16px'
              }}
            >
              WhatsApp
            </button>
            <Link
              to="/kontakt"
              className="btn-primary"
              style={{
                padding: '12px 24px',
                minHeight: '48px',
                fontSize: '16px'
              }}
            >
              Schaden prüfen
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#1a202c',
              cursor: 'pointer',
              padding: '8px'
            }}
          >
            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden" style={{
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            paddingTop: '20px',
            paddingBottom: '20px'
          }}>
            <nav className="flex flex-col gap-4">
              {navLinks.map(link => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setMobileMenuOpen(false)}
                  style={{
                    color: isActive(link.path) ? '#00A8CC' : '#999',
                    fontSize: '18px',
                    fontWeight: '500',
                    textDecoration: 'none',
                    padding: '12px 0'
                  }}
                >
                  {link.label}
                </Link>
              ))}
              <div className="flex flex-col gap-3 mt-4">
                <button onClick={handleWhatsApp} className="btn-secondary" style={{ width: '100%' }}>
                  WhatsApp
                </button>
                <Link to="/kontakt" className="btn-primary" style={{ width: '100%' }} onClick={() => setMobileMenuOpen(false)}>
                  Schaden prüfen
                </Link>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;